//#region Styles
import {
	Part,
	Row,
	Column,
	TitleSection,
	TitleSection2,
	ResumeSection,
} from "components/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import PenIcon from "icons/PenIcon";
import DataField from "views/components/Detail/DataField/DataField";
import DurationDataFields from "views/components/Detail/DurationDataFields/DurationDataFields";
//#region Utils
import { EVENTS_CONSTANTS } from "config/constants";
//#endregion

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const ResumeStep1 = ({ form, allDays, toStep1 }) => {
	//#region Effects
	//#endregion
	//#region Functions
	//#endregion
	const getDataPart = () => {
		const { adviser } = form.part1;
		const dataPart = [
			[
				{
					field: "Organización",
					description: adviser.fullName,
				},
			],
		];
		return dataPart;
	};
	const getDuration = () => {
		const {
			duration: { onlyDay, manyDays },
			periodId,
		} = form.part2;
		if (periodId === EVENT_PERIOD_IDS.ONLY_DAY) {
			return {
				onlyDay,
				manyDays: null,
			};
		}
		return {
			onlyDay: null,
			manyDays,
		};
	};
	return (
		<Part>
			<Row>
				<Column width="max-content">
					<TitleSection>Resumen:</TitleSection>
					<TitleSection2>Detalles de asesoría</TitleSection2>
				</Column>
				<CustomButton
					variant="quintinary"
					text="Editar sección"
					icon={<PenIcon />}
					onClick={toStep1}
				/>
			</Row>
			<ResumeSection>
				<Part
					direction="column"
					gap="15px"
				>
					{getDataPart().map((row, idx1) => {
						return (
							<Column
								key={idx1}
								width="45%"
								gap="20px"
							>
								{row.map((item, idx2) => {
									return (
										<DataField
											key={idx2}
											{...item}
										/>
									);
								})}
							</Column>
						);
					})}
					<DurationDataFields
						allDays={allDays}
						fieldTimeGroup="Horas disponibles:"
						duration={getDuration()}
					/>
				</Part>
			</ResumeSection>
		</Part>
	);
};

export default ResumeStep1;
